import { URLS } from 'config';
import { ReactNode } from 'react';
import { matchPath } from 'react-router-dom';
import { capitalise } from 'utils';
import EnquiryComplete from './Complete';
import EnquiryContactDetails from './ContactDetails';
import EnquiryLanding from './Landing';
import EnquiryProjectBudget from './ProjectBudget';
import EnquiryQuoteComplete from './Quote/Complete';
import EnquiryQuoteConfirmDetails from './Quote/ConfirmDetails';
import EnquiryQuoteContactDetails from './Quote/ContactDetails';
import EnquiryQuoteUploadQuote from './Quote/UploadQuote';
import EnquiryQuoteWelcome from './Quote/Welcome';
import EnquiryWelcome from './Welcome';
import EnquiryWorkDetails from './WorkDetails';

export const getEnquiryContent = (
  url: string,
  isLoading: boolean,
): ReactNode => {
  if (isLoading) return <EnquiryWelcome />;
  const active = Object.values(URLS).find((path) =>
    matchPath(url, {
      path,
      exact: true,
      strict: true,
    }),
  );
  switch (active) {
    case URLS.enquiry:
      return <EnquiryLanding />;
    case URLS.enquiryWelcome:
      return <EnquiryWelcome />;
    case URLS.enquiryContactDetails:
      return <EnquiryContactDetails />;
    case URLS.enquiryWorkDetails:
      return <EnquiryWorkDetails />;
    case URLS.enquiryProjectBudget:
      return <EnquiryProjectBudget />;
    case URLS.enquiryComplete:
      return <EnquiryComplete />;

    case URLS.enquiryQuoteWelcome:
      return <EnquiryQuoteWelcome />;
    case URLS.enquiryQuoteContactDetails:
      return <EnquiryQuoteContactDetails />;
    case URLS.enquiryQuoteUploadQuote:
      return <EnquiryQuoteUploadQuote />;
    case URLS.enquiryQuoteConfirmDetails:
      return <EnquiryQuoteConfirmDetails />;
    case URLS.enquiryQuoteComplete:
      return <EnquiryQuoteComplete />;

    default:
      return null;
  }
};

export const replaceTradingName = (str: string, tradingName: string): string =>
  str.replace(/{{trading_name}}/g, capitalise(tradingName));
